import React, { memo, useEffect, useMemo, useState } from 'react'
import type { IStream } from '../../api/dto/IStream'
import CustomImage from '../customImage/customImage'
import { SportTrial } from '../../types/timer'
import { useUserStreamUrl } from '../../hooks/useUserStreamUrl'
import PricingModal from '../../layout/components/header/components/pricing/pricingModal'
import PricingForm from '../pricingForm'

interface IProps {
  stream: IStream[] | string
  trialInfo?: SportTrial
  isLoggedIn?: boolean
  sportId?: string
}

const resolveStream = (stream: IStream[] | string): IStream | null =>
  typeof stream !== 'string' ? stream[0] : null

const IframeContent = memo(({ content }: { content: string }) => (
  <div className="w-full h-full" dangerouslySetInnerHTML={{ __html: content }} />
))

export const StreamBlock = ({ stream, trialInfo, isLoggedIn, sportId }: IProps) => {
  const [activeStream, setActiveStream] = useState<IStream | null>(resolveStream(stream))

  const streamIframe = useMemo(
    () =>
      (typeof stream === 'string' ? stream : activeStream?.stream || '')
        ?.replace(/width=["'“]\d{3}["'”]/g, 'width="100%"')
        .replace(/width=["'“]\d{2}["'”]/g, 'width="100%"')
        .replace(/height=["'“]\d{3}["'”]/g, 'height="100%"')
        .replace(/height=["'“]\d{2}["'”]/g, 'height="100%"')
        .replace(/"/g, "'")
        .replace(/“/g, "'")
        .replace(/”/g, "'")
        .replace(/percent/g, '%'),
    [stream, activeStream]
  )

  const customStreamIframe = useUserStreamUrl(streamIframe, sportId)

  useEffect(() => {
    if (typeof stream !== 'string') {
      setActiveStream(stream[0])
    }
  }, [stream])

  return (
    <div className="flex flex-col w-full h-full">
      {typeof stream !== 'string' ? (
        <div className="flex items-center bg-whiteOpacity1 p-2">
          {stream.map((el) => {
            const isActive = activeStream?.uuid === el.uuid
            return (
              <div
                key={el.uuid}
                onClick={!isActive ? () => setActiveStream(el) : undefined}
                className={`flex items-center ${isActive ? 'bg-darkBlueOpacity1' : 'bg-darkBlue'} hover:bg-darkBlueOpacity1 text-white px-[12px] py-[10px]  mr-1 rounded-[8px] cursor-pointer h-full`}
              >
                <CustomImage src={el.icon} className="w-[24px] h-[24px]" />
                <span
                  className={`ml-2 text-sm unique:text-base whitespace-nowrap max-w-[50px] unique:max-w-max overflow-hidden text-ellipsis ${isActive ? 'block' : ' hidden'}`}
                >
                  {el.name}
                </span>
              </div>
            )
          })}
        </div>
      ) : null}
      <div className="relative w-full h-full bg-darkBlueOpacity">
        {trialInfo?.isActive && !isLoggedIn ? (
          <span className="absolute right-1 top-1 text-white bg-violet font-rubikBold pl-4 py-2 rounded w-[160px]">
            Trial time: {trialInfo?.timeLeft?.minutes}:{trialInfo?.timeLeft?.seconds}
          </span>
        ) : null}
        <IframeContent content={customStreamIframe} />
      </div>
    </div>
  )
}
